import { useContext } from 'react';
import { NetworkContext } from '../NetworkProvider';


function NetworkBanner() {
  const { isOnline } = useContext(NetworkContext);

  if (isOnline) return null;

  return <div style={styles.banner}>⚠ No Internet Connection</div>;
}

const styles = {
  banner: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    backgroundColor: '#ff4d4f',
    color: 'white',
    textAlign: 'center',
    padding: '10px',
    zIndex: 9999,
  },
};

export default NetworkBanner;
